import requestAll from './request.js';

// const apiUrl = 'http://176.113.70.184:9103/';
// const webUrl = '域名';
// const baseUrl = apiUrl + '?act=';

const api = {

    //     //获取url补充静态资源
    //     getUrl(){
    //         return webUrl;
    //     },url,data,method


    getData(url, data, method) {
        let urls = url
        return requestAll.postRequest(urls, data, method);
    },



}

export default api



// WEBPACK FOOTER //
// ./src/util/api.js